import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import Buttons from "./Buttons/Index";
import React from "react";
import { Back } from "components/common/Icons";
import { TrackedLogo } from "lib/analytics/react/link";

const MobileHeader = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter();
  return (
    <div
      className="sticky top-0  bg-white pl-5 pr-2 py-[14px] h-16 flex justify-between items-center z-[999]"
      style={{
        background: "white",
      }}
    >
      <TrackedLogo
        href="/"
        asTrace={true}
        onClick={() => {
          window.dataLayer.push({
            event: "ClickDetailHeaderLogo",
          });
          sessionStorage.removeItem(`main-scrollPosition`);
          sessionStorage.removeItem(`search-scrollPosition`);
        }}
      >
        <img
          width={30}
          height={30}
          src={`/images/header/headerLogo.svg`}
          alt="logo"
          className="cursor-pointer w-auto h-auto"
        />
      </TrackedLogo>
      {children}
    </div>
  );
};

const DesktopHeader = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter();

  return (
    <div className="sticky top-[60px] w-screen max-w-[800px] z-30  h-14  bg-white opacity-100">
      <div className="pl-3 pr-5 py-[13px] flex justify-between items-center">
        <div className="cursor-pointer" onClick={() => router.back()}>
          <Back fill="gray40" width={24} height={24} />
        </div>
        {children}
      </div>
    </div>
  );
};

const MobileHeaderMemo = React.memo(MobileHeader);
const DesktopHeaderMemo = React.memo(DesktopHeader);

function Header({
  isMobile,
  detailData,
  setAlarmRegister,
  isLoginUser,
}: {
  isMobile: boolean;
  detailData: any;
  setAlarmRegister: any;
  isLoginUser: boolean;
}) {
  if (isMobile) {
    return (
      <MobileHeaderMemo>
        <Buttons
          detailData={detailData}
          setAlarmRegister={setAlarmRegister}
          isLoginUser={isLoginUser}
          isMobile={isMobile}
        />
      </MobileHeaderMemo>
    );
  }
  return (
    <DesktopHeaderMemo>
      <Buttons
        detailData={detailData}
        setAlarmRegister={setAlarmRegister}
        isLoginUser={isLoginUser}
        isMobile={isMobile}
      />
    </DesktopHeaderMemo>
  );
}

const HeaderMemo = React.memo(Header);

export default HeaderMemo;
